import { useContext } from 'react';
import { AuthContext, type AuthState } from './AuthProvider.js';

export function useAuth(): AuthState {
  const context = useContext(AuthContext);
  if (context === null) throw new Error('useAuth must be used inside AuthProvider');
  return context;
}
